import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EqualizerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"equalizer"}/>
}
